export default __webpack_public_path__ + "static/img-nhs-platform-81ba446fbb02957581cbe5ab4912a526.gif";